import * as Yup from 'yup'

export const censusSchema = Yup.object().shape({
  CampamentoId: Yup.string().required('Campamento es requerido'),
  TipoEdificacionId: Yup.string().required('Tipo de Edificación es requerido'),
  ModuloId: Yup.string().required('Módulo es requerido'),
  PisoId: Yup.string().required('Piso es requerido')
})